import React, { useState } from "react";
import {
  Tabs,
  Tab,
  Box,
  Typography,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import UnifiedEHRTimeline from "./UnifiedEHRTimeline";
import CostSummary from "../CostSummary";

const TabPanel = ({ children, value, index }) => {
  return value === index && <Box sx={{ p: 2 }}>{children}</Box>;
};

const MedicalHistory = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const userProfile = location.state;
  const [selectedTab, setSelectedTab] = useState(0);

  // Get patient ID from userProfile
  const patientId = userProfile?.results?.[0]?.id;

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
  };

  if (!patientId) {
    return (
      <Box sx={{ p: 3, textAlign: "center" }}>
        <Typography variant="body1" color="text.secondary">
          Please select a patient to view medical history
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ maxWidth: 1200, mx: "auto", p: 2 }}>
      <Tabs value={selectedTab} onChange={handleTabChange} centered>
        <Tab label={t("profile.timeLine")} />
        <Tab label={t("profile.labResult")} />
        <Tab label={t("profile.imaging")} />
        <Tab label={t("profile.costs")} />
      </Tabs>

      {/* Unified EHR Timeline Tab */}
      <TabPanel value={selectedTab} index={0}>
        <UnifiedEHRTimeline patientId={patientId} />
      </TabPanel>

      {/* Lab Results Tab - Filtered from Unified Timeline */}
      <TabPanel value={selectedTab} index={1}>
        <UnifiedEHRTimeline patientId={patientId} defaultTypeFilter="laboratory" />
      </TabPanel>

      {/* Imaging Results Tab - Filtered from Unified Timeline */}
      <TabPanel value={selectedTab} index={2}>
        <UnifiedEHRTimeline patientId={patientId} defaultTypeFilter="imaging" />
      </TabPanel>

      {/* Costs Tab */}
      <TabPanel value={selectedTab} index={3}>
        <CostSummary patientId={patientId} />
      </TabPanel>
    </Box>
  );
};

export default MedicalHistory;
